import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, mergeMap, Observable, throwError } from 'rxjs';
import { EncryptionService } from '../encryption/encryption.service';
import { environment } from '../../../../environments/environment';
import { LoginService } from 'app/services/login/login.service';
import { CVA_CONSTANTS } from 'app/util/constants';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ResponseInterceptorService implements HttpInterceptor {

  constructor(
    private readonly encryptionService: EncryptionService,
    private readonly loginService: LoginService,
    private dialog: MatDialog,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Logic to parse responses (Eg: redirect to login if error code is 401)
    return next.handle(request).pipe(
      mergeMap(async (event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.url?.includes(environment.cva_url)) {
          const decryptedBody = await this.encryptionService.decryptAllTextFields(event.body);
          return event.clone({ body: decryptedBody });
        }
        return event;
      }),
      catchError((error) => {
        const statusCodes = [401, 423];
        const errorCode = error?.error?.code;
        const isRelevantStatus = statusCodes.includes(error.status) || statusCodes.includes(errorCode);
        if (isRelevantStatus) {
          const isLoggedIn = this.loginService.loggedIn$.value;
          const isLoginUrl = typeof error?.url === 'string' && error.url.endsWith('custom/login') === false;

          if (isLoggedIn) {
            let message = '';
            if (error.status === 423) {
              switch (errorCode) {
                case 'ERR_ACCOUNT_LOCKED':
                  message = CVA_CONSTANTS.MESSAGE.ACCOUNT_LOCKED;
                  break;
                case 'ERR_ACCOUNT_INACTIVE':
                  message = CVA_CONSTANTS.MESSAGE.INACTIVE_ACCOUNT;
                  break;
              }
            }

            if (!error?.error || typeof error?.error !== 'object') {
              error.error = {};
            }

            error.error.errorMessage = message;
            error.error.message = message;
            error.error.status = error.status;

            error = {
              ...error,
              errorMessage: message,
              message,
            };

            this.loginService.logout();
            this.dialog.closeAll();
          } else if (isLoginUrl) {
            localStorage.clear();
            sessionStorage.clear();
          }
        }

        return throwError(() => error); // rethrow the error as observable
      })
    );

  }
}
